import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import styles from "./Events.module.css";
import Button from "@material-ui/core/Button";
import EventsSideBar from "./EventsSideBar";
import EventsView from "./EventsView";
import CustomizedAlert from "../../ReusableComponents/Alert/CustomizedAlert";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTranslation } from "react-i18next";
import { GetStateFromData } from "../../components/CustomHooks/CustomHooks";
import { useDispatch } from "react-redux";
import { updateStateInRedux } from "../../Redux";
import cloneDeep from "lodash-es/cloneDeep";

const useStyles = makeStyles((props) => ({
  list: {
    width: (props) => (!props.ipad ? "100%" : 922),
    height: "var(--app-height-form)",
  },
  fullList: {
    width: "auto",
  },
  paper: {
    overflowY: "unset",
    height: "var(--app-height-form)",
    '& .MuiPaper-root' :{
      // height: "var(--app-height-form) !important",
      overflow: "inherit",
      height: "unset !important",
      top: "unset !important",
    },
    width: (props) => (!props.ipad ? "100%" : null),
  },
}));

const Events = (props) => {
  const dblinking = { label: "DB Linking", value: "DBLinking" };
  const customaction = { label: "Custom Action", value: "CustomAction" };
  const webservice = { label: "Web Service", value: "WebService" };
  const customservice = { label: "Custom Service", value: "CustomWebService" };
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const matches = useMediaQuery("(min-width:1180px)");
  const classes = useStyles({ ipad: matches });
  const contexts = GetStateFromData();
  const anchor =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA"
      ? "left"
      : "right";
  const { showAlertConfirmNotifications, isPortal, isTaskForm, formState2, setFormState2, activeApplication, activePage} =
    contexts.contexts;

  const [eventState, setEventState] = React.useState({
    ...props?.value?.Events,
  });
  let eventObject={}    
  var controls = [];
  var events = [];
  Object.keys(props.json).forEach((k, i) => {
    if (k === props.elemtype) {
      controls = props.json[k].controls;
      events = props.json[k].events;
      eventObject={...eventObject,[props.json[k].events]:{}}
    }
  });
  const originalEventData=cloneDeep(props?.value?.Events || eventObject)
  const [control, setControl] = React.useState();
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification",
  });
  const [state, setState] = React.useState({
    right: false,
  });

  useEffect(() => {}, [eventState]);

  const updation = (name, input) => {
    var count = Object.keys(input).length;
    if (count > 0) {
      setEventState((prevEventState) => {
        return {
          ...prevEventState,
          [name]: input,
        };
      });
    }
  };

  useEffect(() => {}, [eventState]);


  const handleControlUpdate = (x) => {
    setControl(x);
  };

  const toggleDrawer = (anchor, open, eventname) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ [anchor]: open });

    setControl(eventname);
  };

  const handleDone = (e) => {
    
    if(doneButtonsavefunctionality?.current){
      doneButtonsavefunctionality.current(e);
    }
    try {
      if (
        (eventState?.Click?.Command?.Name === "RouteCriteria" &&
          (eventState?.Click?.Command?.Parameters?.FormName === "Select" ||
            !eventState?.Click?.Command?.Parameters?.FormName ||
            eventState?.Click?.Command?.Parameters?.UserName === "Select" ||
            !eventState?.Click?.Command?.Parameters?.UserName ||
            eventState?.Click?.Command?.Parameters?.Password === "Select" ||
            !eventState?.Click?.Command?.Parameters?.Password)) ||
        (eventState?.Click?.Command?.Name === "RouteJourney" &&
          props?.elemtype === "tile" &&
          (eventState?.Click?.Command?.Parameters?.FormName === "Select" ||
            !eventState?.Click?.Command?.Parameters?.FormName ||
            eventState?.Click?.Command?.Parameters?.DecisionField ===
              "Select" ||
            !eventState?.Click?.Command?.Parameters?.DecisionField ||
            eventState?.Click?.Command?.Parameters?.TileName === "Select" ||
            !eventState?.Click?.Command?.Parameters?.TileName)) ||
        (eventState?.Click?.Command?.Name === "RouteJourney" &&
          props?.elemtype === "button" &&
          (eventState?.Click?.Command?.Parameters?.FormName === "Select" ||
            !eventState?.Click?.Command?.Parameters?.FormName ||
            eventState?.Click?.Command?.Parameters?.DecisionField ===
              "Select" ||
            !eventState?.Click?.Command?.Parameters?.DecisionField))
      ) {
        setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "Please fill all the mandatory fields",
        });
      } else {
        setState({ ["right"]: false });
        setControl("");
        props.updateEventData(eventState);
        if(eventState?.Click?.Command?.Name === "RouteCriteria" && (activeApplication?.defaultFormId === activePage?.formId)){
          const updateFormBuffer = {...formState2, routeCriteriaApplied: true}
          dispatch(updateStateInRedux({name: "routeCriteriaApplied", value: true}));
          setFormState2(updateFormBuffer)
        }
        if(eventState?.Click?.Command?.Name !== "RouteCriteria" && (activeApplication?.defaultFormId === activePage?.formId)){
          if(formState2.routeCriteriaApplied){
            delete formState2.routeCriteriaApplied
            dispatch(updateStateInRedux({name: "routeCriteriaApplied", value: false}));
            setFormState2(formState2)
          }
        }
        if(Object.keys(eventState).length!==0){
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "success",
            vertical: "bottom",
            horizontal: "left",
            alertContentKey: "EVENTS_SAVED_SUCCESSFULLY",
            autoHideDuration: 6000,
          });  
          // window.setTimeout(() => {
          //   showAlertConfirmNotifications({
          //     open: false,
          //     showConfirm: "showNotification",
          //     alertType: "success",
          //     vertical: "bottom",
          //     horizontal: "left",
          //     alertContentKey: "EVENTS_SAVED_SUCCESSFULLY",
          //   });
          // }, 1000);
        }
        
      }
    } catch (err) {}
  };
  const handleCancel = (e) => {    
    props.updateEventData(originalEventData);
    setEventState(() => originalEventData);
    toggleDrawer("right", false, "")(e);      
  }
  const doneButtonsavefunctionality= useRef(undefined);

  function doneButtoncallback( function1 ){
    doneButtonsavefunctionality.current= function1;
  }

  const list = (anchor) => (
    <div id={"event_child_iform"} className={classes.list}>
      <header
        style={{
          height: "48px",
          fontFamily: "Open Sans",
          fontSize: " 14px",
          fontWeight: " 600",
          lineHeight: " 16px",
          letterSpacing: " 0px",
          textAlign: " left",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #C4C4C4",
          textTransform: "capitalize"
        }}
      >
        <p style={{ paddingLeft: "12px", margin: "0", fontSize: "14px", fontWeight: "600", lineHeight: "15px" }}>
          {" "}
          Events{" "}
        </p>

        <span
          style={{ borderLeft: "1px solid #c4c4c4", height: "24px", margin: "0 8px" }}
          className="vertical_line_events_header"
        ></span>

        <p style={{ margin: "0", fontSize: "14px", fontWeight: "600", lineHeight: "15px" }}> {` ${props?.control_json?.elem_type} `}</p>
        <p
          style={{
            border: "1px solid #FAE18E",
            fontSize: "12px",
            color: "#606060",
            background: "#FDF3D2",
            margin: "0px 8px",
            padding: "4px"
          }}
        >
          {" "}
          {` ${props?.control_json?.id} `}
        </p>

        <span
          style={{
            fontSize: "10px",
            color: "#606060",
            background: "#FDF3D2",
            border: "1px solid #FAE18E",
            marginLeft: "8px"
          }}
        >
          {props.selectedControlid}
        </span>
      </header>
      <div
        style={
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? {
                direction: "rtl",
                display: "flex",
                height: "calc( var(--app-height-form) - 100px )"
              }
            : {
                display: "flex",
                height: "calc( var(--app-height-form) - 100px )"
              }
        }
      >
        <EventsSideBar
          control_json={props.control_json}
          controls={controls}
          selectedControl={control}
          handleControlUpdate={handleControlUpdate}
        ></EventsSideBar>
        <div role="region" aria-label="Events Header" className={styles.eventview} style={{ position: "relative", paddingBottom: "70px",  width: !matches ? "90%" : null }}>
          {controls.map((ctrl) => {
            return (
              <>
                {control === ctrl.label ? (
                  <EventsView
                    doneButtoncallback={doneButtoncallback}
                    control_json={props.control_json}
                    eventViewState={eventState[ctrl.value]}
                    control={ctrl.value}
                    selectedControl={control}
                    elemtype={props.elemtype}
                    events={
                      isPortal
                        ? ctrl.events
                        : props.elemtype === "tile"
                        ? [dblinking, customaction, webservice, customservice]
                        : ctrl.events
                    }
                    updation={updation}
                  ></EventsView>
                ) : (
                  ""
                )}
              </>
            );
          })}
        </div>
      </div>
      <footer
        className={styles.mainfooter}
        style={
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? { direction: "rtl", width:!matches ? "100%": "922px" }
            : !matches ? {width:"100%"} : null
        }
      >
        <div
          className={styles.divinfooter}
          style={
            window?.psh_configs?.selectedLanguage === "ar" ||
            window?.psh_configs?.selectedLanguage === "ar-SA"
              ? { float: "left" }
              : null
          }
        >
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={`${styles.cancelbtn} formBuilder-MuiButton-outlined`}
            variant="outlined"
            onClick={(e)=>handleCancel(e)}
          >
            {t("Cancel")}
          </Button>
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={`${styles.donebtn} formBuilder-MuiButton-outlined`}
            variant="contained"
            onClick={(e) => handleDone(e)}
          >
            {t("Done")}
          </Button>
        </div>
      </footer>
    </div>
  );
  document
    .querySelector("#event_child_iform")
    ?.parentElement?.setAttribute("tabindex", "none");
  return (
    <div>
      <React.Fragment key={anchor}>
        {controls.map((item) => {
           const eventIdPart = item?.label?.replace(/\s+/g, '').toLowerCase();
           const buttonId = `${props?.control_json?.id}_${eventIdPart}`;
          return (
            <div className={`input ${styles.row}`}>
              {t(item.label)}
              <button
                onClick={toggleDrawer("right", true, item.label)}
                className={styles.eventButton}
                id={buttonId}
              >
                +
              </button>
            </div>
          );
        })}
        <Drawer
          id="event_drawer_iform"
          className={classes.paper + " " + "formBuilder_main_app"}
          classes = {{paper : classes.paper}}
          anchor={anchor}
          open={state["right"]}
          onClose={toggleDrawer("right", false, "")}
          disableEnforceFocus={false}
          enforceFocus={false}
          disablePortal={isTaskForm}
          onFocus={() => console.log("focus")}
        >
          {list("right")}
          {alertData.open === true && <CustomizedAlert alertData={alertData} />}
        </Drawer>
      </React.Fragment>
    </div>
  );
};

export default Events;
